class AccessibilityDetector extends HTMLElement {
    constructor() {
      super();
      this.handleFirstTab = this.handleFirstTab.bind(this);
      this.handleMouseDownOnce = this.handleMouseDownOnce.bind(this);
  
      const style = document.createElement('style');
      style.textContent = `
        /* Hide focus outlines unless user is tabbing */
        *:focus {
          outline: none !important;
        }
  
        body.user-is-tabbing *:focus {
          outline: 2px solid #a29060 !important;
          outline-offset: 2px;
        }
  
        /* Optional: for browsers that support :focus-visible */
        *:focus:not(:focus-visible) {
          outline: none !important;
        }
      `;
  
      document.head.appendChild(style);
    }
  
    connectedCallback() {
      window.addEventListener('keydown', this.handleFirstTab);
    }
  
    disconnectedCallback() {
      window.removeEventListener('keydown', this.handleFirstTab);
      window.removeEventListener('mousedown', this.handleMouseDownOnce);
    }
  
    handleFirstTab(e) {
      if (e.key === 'Tab') {
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', this.handleFirstTab);
        window.addEventListener('mousedown', this.handleMouseDownOnce);
      }
    }
  
    handleMouseDownOnce() {
      document.body.classList.remove('user-is-tabbing');
      window.removeEventListener('mousedown', this.handleMouseDownOnce);
      window.addEventListener('keydown', this.handleFirstTab);
    }
  }
  
  customElements.define('accessibility-detector', AccessibilityDetector);  